import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { AslibGridComponent, AslibTitleService } from '@aslib/components';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { CadastrarValorMensalDistribuicaoService } from '../shared/service/cadastra-valor-mensal-distribuir..service';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';


type Filtro = {
  anoReferencia: string;
};

@Component({
  selector: 'sarf-aprovacao-valor-mensal',
  templateUrl: './aprovacao-valor-mensal.component.html'
})

export class AprovacaoValorMensalComponent implements OnInit {
  @ViewChild('grid') grid: AslibGridComponent;
  ValoresFiltro: any[];
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  DataInicio: Date;
  showFile: ShowFile;
  exibirGrid:boolean = true;
  filtro: Filtro;
  filtroVazio: Filtro = {
    anoReferencia: ''
  };
  dadosValoresDistribuir: any[] = [];
  
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  itemSelecionado: any;
    

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    private readonly _messages : Messages,
    private readonly cadastrarValorMensalDistribuicaoService: CadastrarValorMensalDistribuicaoService,
    private aslibTitleService: AslibTitleService,
    private cd: ChangeDetectorRef
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    
  }


formConsultaRoyalties = new FormGroup({
    dataReferenciaDistribuicao: new FormControl('', Validators.required)
  });

  ngOnInit() {
    this.filtro = { ...this.filtroVazio };
    this.dadosOnInitFormulario(this.modalMensagem);
  }
  

ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Valor Mensal por Município";
    this.aslibTitleService.SubText = "Aprovar"
    this.cd.detectChanges(); 
  });
}



  dadosOnInitFormulario(modal: AslibModalComponent){
    this.observerOnIniftFormulario = this.cadastrarValorMensalDistribuicaoService.dadosOnInitFormulario().subscribe(
      retornoRequest => {
        
            const lista = retornoRequest.ListaValorMensalDistribuicaoRoyalty;

            // 🛡️ GARANTE QUE NUNCA É UNDEFINED
            this.dadosValoresDistribuir = Array.isArray(lista) ? lista : [];

        if(retornoRequest.objetoMensagem &&  
          retornoRequest.objetoMensagem.Mensagem !== null &&  
          retornoRequest.objetoMensagem.Mensagem !== '') {
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }

irPraAdicionar(): void {
    this.router.navigate(['/royalts/sarf-cadastra-valor-mensal-distribuir']);
  }
public limparConsulta(){
      this.formConsultaRoyalties.reset();
      this.filtro = { ...this.filtroVazio };
       this.dadosOnInitFormulario(this.modalMensagem);
 }

editar(conteudo: any, item: any){
  this.itemSelecionado = item;
  const options: IAslibModalOptions = {
      title: 'Detalhes da Valor de Royalties a Distribuir',
      backdrop: 'static',
      footerVisible: true,
      size: 'lg',
      content: conteudo,
      okText:'Salvar',
      cancelarText:'Cancelar',
      okVisible:true,
      cancelarVisible:true
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
}

private toMesAno(value: string | Date): string | null {
  if (!value) return null;
  const d = (value instanceof Date) ? value : new Date(value);
  if (isNaN(d.getTime())) return null; // data inválida
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();
  return `${mes}/${ano}`;
}

gerarRelatorio() {
    
    this._aslibLoadingService.start();
    this.subscription = this.cadastrarValorMensalDistribuicaoService
      .gerarRelatoriodeValoresaDistribuir(this.dadosValoresDistribuir).subscribe(
        data => {
          this.showFile.Windows(data,ExportTypes.Excel_xls,'ValoresADistribuirRoyalty');
        },
        (error: any) => {
          this._aslibLoadingService.complete();
          new AslibModalComponent(this.aslibModalService).open({
            title: 'ERRO',
            text: this._messages.MN0011,
            type: 'erro'
          });
        },
        () => {
          this.unSubscribe();
        }
      );
    }


 /**
     * filtrar
     * Função para filtrar registros
       */
    filtrar(grid: AslibGridComponent) {
      this.ValoresFiltro = this.dadosValoresDistribuir;
    
      if (this.filtro.anoReferencia !== null) {
        this.ValoresFiltro = this.ValoresFiltro.filter(t => {
          if(this.toMesAno(t.DataReferenciaDistribuicao) == this.filtro.anoReferencia){
            return t;}});
      }

      grid.dataset = this.ValoresFiltro;
      if(this.ValoresFiltro.length==0){
        this.showError('Não existem registros para os filtros informados!');
      }
    }

    showError(text: string) {
    this.aslibModal = null;
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.aslibModal.open({
      title: 'Atenção',
      text: text,
      type: 'error',
      backdrop: 'static',
    });
  }

excluir(modal:AslibModalService, item): void {
const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Confirma exclusão do registro atual?`,
      okText: 'Sim',
      cancelarText: 'Não',
      content: null,
      cancelarVisible: true
    };
    modal.open(options).result.then(
      () => {
        // Lógica para excluir o item
        console.log('Item excluído:', item);
      },
      () => {}
    );


}
  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/royalts/aprovacao-valor-municipio/aprovacao-valor-mensal.component.ts